__turbopack_context__.v({
  "menu": "chatTitleMenu-module-scss-module__xdqFAa__menu",
  "popoverContent": "chatTitleMenu-module-scss-module__xdqFAa__popoverContent",
  "title": "chatTitleMenu-module-scss-module__xdqFAa__title",
  "trigger": "chatTitleMenu-module-scss-module__xdqFAa__trigger",
  "triggerTitle": "chatTitleMenu-module-scss-module__xdqFAa__triggerTitle",
});
